export default "__VITE_ASSET__Dgg9NScW__"